import React from 'react'
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { capitalizeFirstLetter } from '../Pages/CommonMethods/CommonMethods';
import { useLocation } from 'react-router-dom';
const HelmetDetails = ({ siteTheme, metaURL, metaTitle, metaDescription, metaKeywords, metaImage, pageTitle, headerSetting, languageDetailsData, structuredData }) => {
    const location = useLocation();
    const segments = location.pathname?.split('/');
    const lastSegment = segments.filter(segment => segment !== '').pop();
    let url = capitalizeFirstLetter(lastSegment?.replace(/-/g, ' '));

    const navigateTranslateChecker = (path) => {
        if (siteTheme?.translate_checkout) {
            return `/${languageDetailsData?.Language_Code}${path}`
        }
        else {
            return `${path}`
        }
    }


    // document.title is handled by Helmet below declaratively
    // useEffect(() => {
    //     const path = window.location.pathname;
    //     const slug = path.split('/').filter(Boolean).pop();

    //     // Only use the slug-based title if metaTitle and pageTitle are not provided
    //     if (!metaTitle && !pageTitle && slug && path !== '/') {
    //         const formattedTitle = slug
    //             .replace(/-/g, ' ')
    //             .split(' ')
    //             .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    //             .join(' ');
    //         document.title = formattedTitle;
    //     } else {
    //         document.title = metaTitle || pageTitle || "Flicknexs";
    //     }
    // }, [metaTitle, pageTitle, location.pathname]);


    const currentPath = location.pathname.toLowerCase();
    const siteTitle = headerSetting?.website_name || '';
    const siteDesc = headerSetting?.website_description || 'Your Shows Online';
    const siteLogo = headerSetting?.logo_url;
    const siteFavicon = headerSetting?.favicon_url;

    const websiteUrl = process.env.REACT_APP_Baseurl_Frontend || window.location.origin;

    return (
        <Helmet>
            <title>{metaTitle || pageTitle || siteTitle}</title>
            <meta name="title" content={metaTitle || pageTitle || siteTitle} />
            <meta name="description" content={metaDescription || siteDesc} />
            {metaKeywords && <meta name="keywords" content={metaKeywords} />}
            <meta property="og:description" content={metaDescription || siteDesc} />
            <meta property="og:url" content={metaURL || websiteUrl} />
            <meta property="og:title" content={metaTitle || siteTitle} />
            <meta property="og:site_name" content={siteTitle} />
            <meta property="og:logo" content={siteLogo} />
            <meta property="og:image" content={metaImage || siteFavicon || siteLogo} />
            <meta property="twitter:title" content={metaTitle || siteTitle} />
            <meta property="twitter:description" content={metaDescription || siteDesc} />
            <meta property="twitter:site" content={websiteUrl} />
            <meta property="twitter:image" content={metaImage || siteFavicon || siteLogo} />
            <link rel="icon" type="image/x-icon" href={headerSetting?.favicon_url} sizes={`${headerSetting?.logo_height}x${headerSetting?.logo_width}`} />
            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    )
}
const mapStateToProps = state => ({
    headerSetting: state.get_headerIndex_Reducer.headerSetting,
    languageDetailsData: state.get_getUserTranslateLanguage_Reducer.languageDetailsData,
    siteTheme: state.get_siteTheme_Reducer.siteTheme,
});
export default connect(mapStateToProps)(HelmetDetails)